import { Command as CommandPrimitive } from 'cmdk';
import type { ComponentPropsWithoutRef, ComponentRef, Ref } from 'react';

/**
 * Represents a command component.
 */
export const Command = ({
  className,
  ref,
  ...props
}: ComponentPropsWithoutRef<typeof CommandPrimitive> & {
  ref?: Ref<ComponentRef<typeof CommandPrimitive>>;
}) => (
  <CommandPrimitive
    onClick={(event) => {
      event.stopPropagation();
      event.preventDefault();
    }}
    ref={ref}
    className={className}
    {...props}
  />
);

Command.displayName = CommandPrimitive.displayName;
